import { api } from '@/api'
import qs from 'qs'

interface GetSurveyParams {
  perPage: number
  page: number
  q?: any
  include: string,
  resource?: string,
  resourceId?: number,
  includeStatus?: string,
  surveyReportId?: number,
  includeResourceDetails?: boolean,
  locationId?: number | string,
  reportId?: number
  includeAsset?: boolean
}

export default {
  get: ({ perPage, page, q, include }: GetSurveyParams) => api.$get('/surveys', {
    params: {
      include,
      page,
      per_page: perPage,
      q
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }),
  post: (survey: any, { include }: any) => api.$post('/surveys', survey, {
    headers: {
      content_type: 'multipart/form-data'
    },
    params: { include }
  }),
  patch: (id: string | number, survey: any, params: any) => api.$patch(`/surveys/${id}`, survey, {
    params: { ...params },
    paramsSerializer: (params: any) => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }),
  reviewSurvey: (surveyId: number) => api.$get(`/surveys/${surveyId}/review_surveys`, {
    params: {
      include: 'survey_template, survey_template/questions, survey_template/questions/answer_type, survey_template/questions/answer_choices, observations, observations/answer_choice, observations/answer_choices, observations/question, observations/user'
    },
    paramsSerializer: params => {
      return qs.stringify(params, { arrayFormat: 'brackets' })
    }
  }),
  getSurveyReportsByResource: ({ perPage, page, q, include, resource, resourceId, includeResourceDetails, includeAsset }: GetSurveyParams) =>
    api.$get(`/${resource}/${resourceId}/survey_reports`, {
      params: {
        include,
        page,
        per_page: perPage,
        q,
        includeResourceDetails,
        includeAsset
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }),
  getSurveyReportById: ({ perPage, page, q, include, surveyReportId }: GetSurveyParams) =>
    api.$get(`/surveys/${surveyReportId}`, {
      params: {
        include,
        page,
        per_page: perPage,
        q
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }),
  getSurveyReportsByAssetId: ({ perPage, page, q, include, resourceId, includeResourceDetails }: GetSurveyParams) =>
    api.$get(`/equipments/${resourceId}/trip_equipments/survey_reports`, {
      params: {
        include,
        page,
        per_page: perPage,
        q,
        includeResourceDetails
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }),
  getSurveyReportsByEquipmentReportId: ({ perPage, page, q, include, reportId, includeResourceDetails, locationId }: GetSurveyParams) =>
    api.$get(`/locations/${locationId}/equipment_reports/${reportId}`, {
      params: {
        include,
        page,
        per_page: perPage,
        q,
        includeResourceDetails
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }),
  getSurveyReportsByResourceID: ({
    perPage,
    page,
    q,
    include,
    locationId,
    resourceId,
    includeResourceDetails,
    resourceType
  }: GetSurveyParams & { resourceType?: 'equipments' | 'work_orders' | 'trips' }) =>
    api.$get(resourceType === 'equipments'
      ? `/locations/${locationId}/equipments/${resourceId}/equipment_reports`
      : `/${resourceType}/${resourceId}/equipment_reports`, {
      params: {
        include,
        page,
        per_page: perPage,
        q,
        ...(resourceType === 'equipments' && { includeResourceDetails })
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'brackets' })
      }
    }),
  getDeficiencyReportByResourceID: ({
    resourceType,
    resourceId,
    surveyReportId,
    ...queryParams
  }: {
  resourceType: 'equipments' | 'work_orders' | 'trips'
  resourceId: string | number
  surveyReportId: string | number
  [key: string]: any;
}) =>
    api.$get(
    `/${resourceType}/${resourceId}/equipment_reports/${surveyReportId}/deficiency_report`,
    {
      params: queryParams,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
    }),

  getRepairReportByResourceID: ({
    resourceType,
    resourceId,
    surveyReportId,
    ...queryParams
  }: {
    resourceType: 'equipments' | 'work_orders' | 'trips'
    resourceId: string
    surveyReportId: string
    [key: string]: any;
  }) =>
    api.$get(
    `/${resourceType}/${resourceId}/survey_reports/${surveyReportId}/repair_report`,
    {
      params: queryParams,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
    }
    )

}
